import React, { useState } from 'react';
import cn from 'classnames';

import PopOver from 'chameleon/ui-stack/ui/base/popover';
import Icon from 'chameleon/ui-stack/ui/base/icon';
import Button from 'chameleon/ui-stack/ui/base/button';
import { hasStudentAnyCAS } from 'chameleon/legacy/src/components/assignment/Assignment/components/AssignmentTable/ColumnCAS/utils';
import StudentSettingsPopoverContent from './StudentSettingsPopoverContent';

const StudentSettingsData = (props) => {
  const { assignment } = props;

  const [popOnHover, setPopOnHover] = useState(true);

  if (assignment.print_toggle) {
    return null;
  }

  const shouldHidePopover = assignment.student_settings.every(
    (customSetting) => !hasStudentAnyCAS({ assignment, customSetting }),
  );

  if (shouldHidePopover) {
    return null;
  }

  return (
    <PopOver
      className={cn('AssignmentStudentSettingsPopover')}
      trigger={(buttonProps, isOpen, reference) => (
        <Button
          {...buttonProps}
          ref={reference}
          isIcon
          isNaked
          accessibility={{
            'aria-expanded': isOpen,
          }}
        >
          <Icon
            name="cas"
            onClick={() => setPopOnHover(false)}
            accessibility={{ 'aria-hidden': true }}
          />
        </Button>
      )}
      popOnHover={popOnHover}
      position="center"
      withPortal
      hideArrow
      accessibility={{
        'aria-label': `${assignment.title} ${assignment.section_name} CAS setting`,
      }}
      accessibilityOmit={['aria-haspopup']}
      focusOrder={['floating', 'content', 'reference']}
      onClose={() => setPopOnHover(true)}
    >
      <StudentSettingsPopoverContent
        assignment={assignment}
        studentsBySection={props.studentsBySection}
        isSPP={props.isSPP}
      />
    </PopOver>
  );
};

export default StudentSettingsData;
